import axios, { AxiosInstance } from 'axios';

import { Configuration, ProjectDto } from 'src/Services/API/generated';

export class ProjectExtendedApi {
  private axiosInstance: AxiosInstance;

  constructor(configuration: Configuration) {
    this.axiosInstance = axios.create({
      baseURL: configuration.basePath ?? '',
      ...configuration.baseOptions,
    });
  }

  async addAttachments(
    assetId: string,
    projectId: string,
    attachmentIds: string[]
  ): Promise<ProjectDto> {
    const response = await this.axiosInstance.post<ProjectDto>(
      `/assets/${assetId}/projects/${projectId}/attachments`,
      { attachmentIds }
    );
    return response.data;
  }
}
